import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CElementsMarqueursComponent, DynamicMarqueurFontSizePipe, MarqueurformValidityPipe } from './c-elements-marqueurs.component';
import { IonicModule } from '@ionic/angular';

import { CdkDrag } from '@angular/cdk/drag-drop';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    CdkDrag
  ],
  declarations: [
    CElementsMarqueursComponent,
    MarqueurformValidityPipe,
    DynamicMarqueurFontSizePipe,
  ],
  exports: [
    CElementsMarqueursComponent,
    MarqueurformValidityPipe,
    DynamicMarqueurFontSizePipe,
  ]
})
export class CElementsMarqueursModule { }
